import { Button, Col, Form, Input, Row } from "antd";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";

const StyledFilterContainer = styled.div`
  &,
  & .filter {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    &__item {
      margin: 0.5rem;

      & .ant-form-item {
        margin: 0;
      }

      &--submit {
        align-self: flex-end;
      }
    }
  }
`;

export const AppPurchaseCodesFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(Object.fromEntries(searchParams));
  }, [form, searchParams]);

  const onSearch = (values: Record<string, string>) => {
    const params: Record<string, string> = {};
    Object.entries(values).forEach(([key, value]) => {
      if (value) params[key] = value;
    });
    setSearchParams(params);
  };

  const onReset = () => {
    form.resetFields();
    setSearchParams({});
  };

  return (
    <StyledFilterContainer>
      <Form
        form={form}
        name="purchase-codes-filter-form"
        onFinish={onSearch}
        layout="vertical"
        style={{ width: "100%" }}
      >
        <Row className="filter">
          <Col xs={20} sm={6} md={5} lg={4} className="filter__item">
            <Form.Item name="skuCode" label="SKU Code">
              <Input placeholder="Search by SKU Code" size="small" allowClear />
            </Form.Item>
          </Col>
          <Col xs={20} sm={6} md={5} lg={4} className="filter__item">
            <Form.Item name="name" label="Name">
              <Input placeholder="Search by Name" size="small" allowClear />
            </Form.Item>
          </Col>
          <Col xs={20} sm={4} md={2} lg={2} className="filter__item filter__item--submit">
            <Form.Item>
              <Button type="primary" htmlType="submit" size="small">
                Search
              </Button>
            </Form.Item>
          </Col>
          <Col xs={20} sm={4} md={2} lg={2} className="filter__item filter__item--submit">
            <Form.Item>
              <Button size="small" onClick={onReset}>
                Reset
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </StyledFilterContainer>
  );
};
